import React from "react"

const clearStyle = {
    clear: "both"
}

const Clear = () => {
    return <div className="Clear" style={clearStyle} />
}

export default Clear
